// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://crpxcsrljmdcrgnedfxb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNycHhjc3Jsam1kY3JnbmVkZnhiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwODk4MDEsImV4cCI6MjA3MDY2NTgwMX0.nck8fXjf1Y43T5ji89qKwZVLZGBo-qPgSnl02QHvA-M";

// Validate configuration
if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  console.error('Missing Supabase configuration:', {
    url: !!SUPABASE_URL,
    key: !!SUPABASE_PUBLISHABLE_KEY
  });
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Ensure JWT token is properly transmitted
    storageKey: 'supabase.auth.token'
  },
  global: {
    headers: {
      'x-client-info': 'zoocertica-app'
    }
  },
  realtime: {
    // Ensure realtime connections include proper auth
    params: {
      eventsPerSecond: 2
    }
  }
});